import {
    PrimaryButton,
    SecondaryButton,
} from "../../../../../../../components";
import ContainerModal from "../../../../../../../components/molecules/modals/container-modal";
import * as s from "./styled-delete-confirmation-activity";

export type TDeleteConfirmation = {
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    onConfirm: () => void;
};

export const DeleteConfirmationModal = ({
    setOpen,
    onConfirm,
}: TDeleteConfirmation) => {
    return (
        <ContainerModal>
            <s.Container
                onKeyDown={(e) => {
                    if (e.key === "Escape") {
                        setOpen(false);
                    }
                    if (e.key === "Enter") {
                        onConfirm();
                    }
                }}
            >
                <s.Title>Deletar atividade</s.Title>
                <s.Description>
                    Ao deletar a atividade, esta ação não poderá ser desfeita.
                </s.Description>
                <s.Buttons>
                    <SecondaryButton
                        onClick={() => {
                            setOpen(false);
                        }}
                    >
                        CANCELAR
                    </SecondaryButton>
                    <PrimaryButton
                        onClick={() => {
                            setOpen(false);
                            onConfirm();
                        }}
                    >
                        DELETAR
                    </PrimaryButton>
                </s.Buttons>
            </s.Container>
        </ContainerModal>
    );
};
